// extracted by mini-css-extract-plugin
module.exports = {"infoDescription":"_02d7e71","infoValue":"_29d8325","standard":"_7a00e34","inline":"_9741598","miniDetail":"_5fa7053","noBottom":"_166fd54"};